import { render, staticRenderFns } from "./RecipientDetails.vue?vue&type=template&id=9629e18a&"
import script from "./RecipientDetails.vue?vue&type=script&lang=js&"
export * from "./RecipientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports